<template>
  <div class="preview-experience">
    <div class="section-header">
      <h3>Preview your experience</h3>
      <p>This is how your campaign will look on mobile devices.</p>
    </div>
    <div class="preview-image-container">
      <img src="@/assets/scroller.png" alt="Campaign Preview" class="preview-image" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PreviewExperience',
})
</script>

<style scoped>
.preview-experience {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.75rem 1.25rem; /* 60px 20px */
  background-color: var(--color-background);
  min-height: 100vh;
}

.preview-image-container {
  width: 100%;
  max-width: var(--base-layout-section-max-width);
  display: flex;
  justify-content: center;
}

.preview-image {
  width: 100%;
  height: auto;
  max-width: 100%;
  border-radius: 1.25rem; /* 20px */
  box-shadow: 0 1.25rem 3.125rem rgba(0, 0, 0, 0.5); /* 20px 50px */
}
</style>
